<div class="flex h-screen flex-col">
  <app-header></app-header>
  <main class="scrollbar flex-grow overflow-auto bg-secondary-greys-50">
    <router-outlet></router-outlet>
  </main>
</div>
<app-toast></app-toast>
